var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{class:[
    'image-text',
    ("image-text--" + (_vm.data.orientation)) ]},[_c('div',{staticClass:"c-container"},[_c('AppPicture',{staticClass:"image-text__picture",attrs:{"data":{ url: _vm.data.image }}}),_c('AppTextBlock',{staticClass:"image-text__content",attrs:{"data":{ content: _vm.data.alt }}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }